import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { MTracingItem } from '../../models/tracing-item-model';

@Component({
  selector: 'status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

  constructor() { }

  @Output() private accept = new EventEmitter<string>();
  @Output() private dismiss = new EventEmitter<string>();
  @Output() private reject = new EventEmitter<string>();
  @Input() public item: MTracingItem = null;

  ngOnInit() {
    // console.log(this.item)
  }

  public onDismiss(text: string){
    this.dismiss.emit(text)
  }

  public onAccept(text: string){
    this.accept.emit(text)
  }

  public onReject(text: string){
    this.reject.emit(text)
  }

}
